import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Crown } from "lucide-react";
import { useSubscription } from "@/hooks/useSubscription";
import { UsageMeter } from "@/components/subscription/UsageMeter";
import { Skeleton } from "@/components/ui/skeleton";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
export function SubscriptionUsage() {
  const {
    t
  } = useTranslation("profile");
  const {
    subscriptionData,
    isLoading,
    formatResetDate
  } = useSubscription();
  if (isLoading) {
    return <SubscriptionUsageSkeleton />;
  }
  if (!subscriptionData) {
    return null;
  }
  const resetDateFormatted = formatResetDate(subscriptionData.resetDate);
  return;
}
function SubscriptionUsageSkeleton() {
  return <Card className="mb-6">
      <CardHeader>
        <div className="flex justify-between">
          <div>
            <Skeleton className="h-5 w-40 mb-2" />
            <Skeleton className="h-4 w-60" />
          </div>
          <Skeleton className="h-6 w-20" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Skeleton className="h-5 w-32 mb-1" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-2 w-full" />
            <Skeleton className="h-3 w-24 mt-1" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-5 w-32 mb-1" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-2 w-full" />
            <Skeleton className="h-3 w-24 mt-1" />
          </div>
        </div>
      </CardContent>
    </Card>;
}